function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.99999 14.4999C5.067 14.4999 3.49999 16.0669 3.49999 17.9999C3.49999 19.9329 5.067 21.4999 6.99999 21.4999C8.93299 21.4999 10.5 19.9329 10.5 17.9999C10.5 16.0669 8.93299 14.4999 6.99999 14.4999ZM7.00001 19.5001C6.17158 19.5001 5.50001 18.8286 5.50001 18.0001C5.50001 17.1717 6.17158 16.5001 7.00001 16.5001C7.82843 16.5001 8.50001 17.1717 8.50001 18.0001C8.50001 18.8286 7.82843 19.5001 7.00001 19.5001ZM15 11H7C3.13401 11 0 14.134 0 18C0 21.866 3.13401 25 7 25H15C18.866 25 22 21.866 22 18C22 14.134 18.866 11 15 11ZM15 22.9999H6.99999C4.23857 22.9999 1.99999 20.7613 1.99999 17.9999C1.99999 15.2385 4.23857 12.9999 6.99999 12.9999H15C17.7614 12.9999 20 15.2385 20 17.9999C20 20.7613 17.7614 22.9999 15 22.9999Z",
  fill: "#FF6600"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.901 24.5001V12.4301H40.644C43.415 12.4301 44.639 13.5691 44.639 15.3711C44.639 16.3571 44.265 17.4451 42.786 18.0061V18.0401C44.673 18.5331 45.268 19.6891 45.268 21.1001C45.268 23.0721 44.01 24.5001 41.273 24.5001H35.901ZM39.029 17.1901H40.338C41.086 17.1901 41.443 16.8331 41.443 16.2211C41.443 15.6431 41.205 15.2351 40.151 15.2351H39.029V17.1901ZM39.029 21.7291H40.695C41.477 21.7291 41.919 21.3381 41.919 20.6241C41.919 19.9441 41.477 19.5531 40.695 19.5531H39.029V21.7291Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.5256 24.5001V12.4301H54.5496V15.3031H49.6536V17.1221H53.4786V19.8761H49.6536V21.6271H54.9066V24.5001H46.5256Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.1641 24.5001L59.4071 12.4301H62.8581L64.6091 19.1961H64.6601L66.2751 12.4301H69.6751L71.2561 19.1791H71.3071L73.0581 12.4301H76.5091L72.7521 24.5001H69.8111L68.0261 17.1561H67.9921L66.1051 24.5001H63.1641Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.7722 24.6701C79.0662 24.6701 76.4993 22.1371 76.4993 18.4651C76.4993 14.7931 79.0662 12.2431 82.7722 12.2431C86.4442 12.2431 89.0452 14.7591 89.0452 18.4651C89.0452 22.1541 86.4442 24.6701 82.7722 24.6701ZM82.7722 21.6611C84.4722 21.6611 85.6452 20.2501 85.6452 18.4651C85.6452 16.6971 84.4722 15.2691 82.7722 15.2691C81.0892 15.2691 79.8992 16.6801 79.8992 18.4651C79.8992 20.2501 81.0892 21.6611 82.7722 21.6611Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.4537 24.5001V12.4301H93.7177L96.7437 18.4311H96.7777L99.7697 12.4301H103.051V24.5001H99.8547V18.5671H99.8037L97.7807 22.3241H95.7237L93.7007 18.5331H93.6497V24.5001H90.4537Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.912 24.5001L108.298 12.4301H111.392L115.761 24.5001H112.395L111.783 22.5451H107.907L107.295 24.5001H103.912ZM108.74 19.8421H110.95L109.862 16.3571H109.828L108.74 19.8421Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.634 24.5001V12.4301H119.711L123.978 19.2641L124.012 19.2471V12.4301H127.191V24.5001H124.012L119.83 17.8871H119.796V24.5001H116.634Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 128,
    height: 36,
    viewBox: "0 0 128 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/logo-secondary.c66149b5.svg";
export { SvgComponent as ReactComponent };